import styled from 'styled-components';

export const FormGroup = styled.div`
  padding: 1rem 0;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  border-bottom: 1px dashed #e7eaec;
  align-items: center;
`;

export const FormControl = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 48%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  align-items: center;
  > input {
    flex: 0 1 auto;
  }
  > p {
    display: flex;
    flex-basis: 100%;
    margin: 10px 110px 0 0;
  }
`;

export const Label = styled.label`
  width: 100px;
  margin-left: 10px;
  flex: 0 1 auto;
`;
